const YUAN_RATE = 13.2;
const TELEGRAM_ACCOUNT_URL = "https://telegram.me/Sobolyusik";
const MAX_ACCOUNT_URL =
    "https://max.ru/u/f9LHodD0cOJ7fBSy5MHfmJzKcVQCJm5rQCCfqTKbejWU5zIxyBmQXEtxgME";
const RESULT_UPDATE_DELAY = 260;
const ACTION_EXIT_DURATION = 140;

const initDeliveryCalculator = (root) => {
    const calculator = root.querySelector("[data-delivery-calculator]");
    if (!calculator) return;

    const deliveryControl = calculator.querySelector(
        "[data-calculator-delivery]",
    );
    const routeControls = [
        ...calculator.querySelectorAll("[data-calculator-route]"),
    ];
    const routeMap = calculator.querySelector("[data-calculator-route-map]");
    const priceControl = calculator.querySelector("[data-calculator-price]");
    const insuranceControl = calculator.querySelector(
        "[data-calculator-insurance]",
    );
    const weightControl = calculator.querySelector("[data-calculator-weight]");
    const result = calculator.querySelector("[data-calculator-result]");
    const submitButton = calculator.querySelector("[data-calculator-submit]");
    const messengers = calculator.querySelector("[data-calculator-messengers]");
    const telegramLink = calculator.querySelector(
        '[data-calculator-messenger="telegram"]',
    );
    const maxLink = calculator.querySelector(
        '[data-calculator-messenger="max"]',
    );
    const wechatLink = calculator.querySelector(
        '[data-calculator-messenger="wechat"]',
    );
    const copyStatus = calculator.querySelector(
        "[data-calculator-copy-status]",
    );
    const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
    ).matches;

    if (
        !deliveryControl ||
        !routeControls.length ||
        !routeMap ||
        !priceControl ||
        !insuranceControl ||
        !weightControl ||
        !result ||
        !submitButton ||
        !messengers ||
        !telegramLink ||
        !maxLink ||
        !wechatLink
    ) {
        return;
    }

    const resultFormatter = new Intl.NumberFormat("ru-RU", {
        maximumFractionDigits: 0,
    });
    const valueFormatter = new Intl.NumberFormat("ru-RU", {
        maximumFractionDigits: 2,
    });

    let calculatorMessage = "";
    let resultUpdateTimer = null;
    let resultAnimationFrame = null;

    const animateResult = () => {
        if (prefersReducedMotion) return;

        result.classList.remove("is-updating");
        if (resultAnimationFrame) cancelAnimationFrame(resultAnimationFrame);
        resultAnimationFrame = requestAnimationFrame(() => {
            result.classList.add("is-updating");
            resultAnimationFrame = null;
        });
    };

    result.addEventListener("animationend", () => {
        result.classList.remove("is-updating");
    });

    const updateMessengerLinks = (price, weight, amountInRubles) => {
        const delivery = deliveryControl.selectedOptions[0]?.textContent.trim();
        const insurance =
            insuranceControl.selectedOptions[0]?.textContent.trim();
        const formattedResult = resultFormatter.format(amountInRubles);

        calculatorMessage =
            "Здравствуйте! Рассчитал(а) стоимость доставки на сайте HaiTao: " +
            `способ доставки — ${delivery}, стоимость товара — ${valueFormatter.format(price)} CNY, ` +
            `вес — ${valueFormatter.format(weight)} кг, страховка — ${insurance}. ` +
            `Предварительная стоимость доставки — ${formattedResult} ₽. ` +
            "Подскажите, пожалуйста, итоговую стоимость и детали доставки.";

        const encodedMessage = encodeURIComponent(calculatorMessage);
        telegramLink.href = `${TELEGRAM_ACCOUNT_URL}?text=${encodedMessage}`;
        maxLink.href = `${MAX_ACCOUNT_URL}?text=${encodedMessage}`;
    };

    const updateResult = (shouldAnimate = true) => {
        const price = Number.parseFloat(priceControl.value);
        const insurance = Number.parseFloat(insuranceControl.value);
        const weight = Number.parseFloat(weightControl.value);

        if (
            !Number.isFinite(price) ||
            !Number.isFinite(insurance) ||
            !Number.isFinite(weight) ||
            price < 0 ||
            weight <= 0
        ) {
            result.textContent = "—";
            calculatorMessage = "";
            return false;
        }

        const roundedWeight = Math.ceil(weight);
        const isCargo = deliveryControl.value === "cargo";
        const exactWeightRate = isCargo ? 39 : 35;
        const fixedFee = isCargo ? 0 : 15;
        const amountInYuan =
            price * 0.05 +
            price * insurance +
            8 * roundedWeight +
            exactWeightRate * weight +
            fixedFee;
        const amountInRubles = Math.round(amountInYuan * YUAN_RATE);

        const nextResult = `${resultFormatter.format(amountInRubles)} ₽`;
        const hasResultChanged = result.textContent.trim() !== nextResult;

        result.textContent = nextResult;
        if (shouldAnimate && hasResultChanged) animateResult();
        updateMessengerLinks(price, weight, amountInRubles);

        return true;
    };

    const scheduleResultUpdate = () => {
        if (resultUpdateTimer) clearTimeout(resultUpdateTimer);
        resultUpdateTimer = setTimeout(() => {
            updateResult();
            resultUpdateTimer = null;
        }, RESULT_UPDATE_DELAY);
    };

    const setDelivery = (delivery, shouldAnimate = true) => {
        deliveryControl.value = delivery;
        routeControls.forEach((control) => {
            control.checked = control.value === delivery;
        });
        routeMap.classList.toggle("is-cargo", delivery === "cargo");
        updateResult(shouldAnimate);
    };

    deliveryControl.addEventListener("change", () => {
        setDelivery(deliveryControl.value);
    });
    routeControls.forEach((control) => {
        control.addEventListener("change", () => {
            if (control.checked) setDelivery(control.value);
        });
    });
    priceControl.addEventListener("input", scheduleResultUpdate);
    insuranceControl.addEventListener("change", updateResult);
    weightControl.addEventListener("input", scheduleResultUpdate);
    submitButton.addEventListener("click", () => {
        if (!updateResult()) return;

        const revealMessengers = () => {
            submitButton.hidden = true;
            submitButton.classList.remove("is-leaving");
            messengers.hidden = false;
            messengers.classList.add("is-entering");
            telegramLink.focus();
        };

        if (prefersReducedMotion) {
            revealMessengers();
            return;
        }

        submitButton.classList.add("is-leaving");
        setTimeout(revealMessengers, ACTION_EXIT_DURATION);
    });
    wechatLink.addEventListener("click", async () => {
        if (!calculatorMessage || !navigator.clipboard) return;

        try {
            await navigator.clipboard.writeText(calculatorMessage);
            if (copyStatus) {
                copyStatus.textContent =
                    "Текст сообщения скопирован в буфер обмена.";
            }
        } catch {
            if (copyStatus) {
                copyStatus.textContent =
                    "Не удалось скопировать текст сообщения.";
            }
        }
    });

    setDelivery(deliveryControl.value, false);
};

export { initDeliveryCalculator };
